import React from 'react';
import { shape, arrayOf, bool } from 'prop-types';
import { ConsumerCardMessaging } from '@thd-olt-component-react/consumer-card-messaging';

export const FinancingOffer = ({ isAppliance, products }) => {
  let mapAbovePrice = false;
  const introOfferPrice = '100.00';
  const initialTotal = 0;
  const calculatedTotal = products.reduce((total, item) => {
    const pricing = item.pricing || null;
    if (!pricing) return total;
    if (pricing.mapAboveOriginalPrice !== null) {
      mapAbovePrice = true;
    }
    return total + pricing.value || 0;
  }, initialTotal).toFixed(2);
  return (
    <ConsumerCardMessaging
      bundlePrice={mapAbovePrice ? introOfferPrice : calculatedTotal}
      paymentEstimatorVersion="v1.0.41"
      isAppliance={isAppliance}
    />
  );
};

FinancingOffer.displayName = 'FinancingOffer';

FinancingOffer.propTypes = {
  isAppliance: bool,
  products: arrayOf(shape({})),
};

FinancingOffer.defaultProps = {
  isAppliance: true,
  products: []
};
